import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { JsonViewerDialogService } from '../../dialogs/json-viewer/json-viewer.service.dialog';
import { Job, JobInterface } from '@contracts/interfaces/job.interface';
import { FilterService } from '../../services/filter.service';
import { JobService } from '../../services/job.service';

@Component({
  selector: 'app-automation',
  templateUrl: './automation.component.html',
  styleUrls: ['./automation.component.scss', '../table.scss']
})
export class AutomationComponent implements OnInit {

  dataSource: MatTableDataSource<Job>;
  columnsToDisplay = [
    'state',
    'date',
    'job',
    'log'
  ];

  currentDate: Date;
  startDate: Date;
  endDate: Date;

  weekOffset: number = 0;

  updateInterval: any;

  constructor(
    private jobService: JobService, 
    private filterService: FilterService,
    private jsonViewerDialogService: JsonViewerDialogService) { }

  ngOnInit(): void {
    this.loadJobs();
    
    this.updateInterval = setInterval(async () => {
      this.loadJobs();
    }, 750);
  }

  ngOnDestroy() {
    clearInterval(this.updateInterval)
  }

  loadJobs() {
    this.filterService.reset();
    let query = this.filterService.query;

    let date = new Date(new Date().getTime() - (1000 * 60 * 60 * 24 * 7 * this.weekOffset))

    let first = setToMonday(date);
    first.setHours(0, 0, 0, 0);

    let last = new Date(first.getTime());
    last.setDate(first.getDate() + 6); // last day is the first day + 6
    last.setHours(23, 59, 59);

    this.startDate = first;
    this.endDate = last;

    let temp = {};
    if (first != null) {
      temp["$gt"] = first;
    }

    if (last != null) {
      temp["$lt"] = last;
    }

    query["date.start"] = temp;

    this.jobService.find(query).subscribe((jobs: Job[]) => {
      this.dataSource = new MatTableDataSource<Job>(jobs);
    });
  }

  reload() {
    this.loadJobs();
  }

  filterFor(filter) {

  }

  filterForAll() {

  }

  nextWeek() {
    if (this.weekOffset > 0) {
      this.weekOffset--;
      this.reload();
    }
  }

  previousWeek() {
    this.weekOffset++;
    this.reload();
  }

  openJobDialog(job: any) {
    
    this.jsonViewerDialogService.open(job);
  }


  clicky(job: Job) {
    console.log(job);
  }

  createConsoleLogJob() {
    this.jobService.create({
      job: Job.CONSOLELOG,
      date: {
        start: new Date(),
        // recurring: 10,
        // limit: 5
      },
      data: {
        message: "Test"
      }
    }).subscribe(r => {
      this.reload();
    })
  }

  createEmailJob() {
    this.jobService.create({
      job: Job.EMAIL,
      date: {
        start: new Date(),
        recurring: 5
      },
      data: {
        template: "test",
        to: "darklocker@gmail.com",
        templateVariables: {
          message: "This is a test email"
        }
      }
    }).subscribe((r: any) => {
      this.reload();
    })
  }

  createSMSJob() {
    this.jobService.create({
      job: Job.SMS,
      date: {
        start: new Date()
      },
      data: {
        template: "google-review",
        to: "+61466040720",
        templateVariables: {
          toName: "Bart Simpson"
        }
      }
    }).subscribe((r: any) => {
      this.reload();
    })
  }

  invoiceReminderJob() {
    this.jobService.create({
      job: Job.INVOICE_REMINDER,
      date: {
        start: new Date()
      },
      data: {
        invoice: 604
      }
    }).subscribe((r: any) => {
      this.reload();
    });
  }

  bankSyncJob() {
    this.jobService.create({
      job: Job.BANK_SYNC,
      date: {
        start: new Date()
      },
      data: {}
    }).subscribe((r: any) => {
      this.reload();
    });
  }

  backupJob() {
    this.jobService.create({
      job: Job.BACKUP,
      date: {
        start: new Date(),
      },
      data: {}
    }).subscribe((r: any) => {
      this.reload();
    });
  }

  getLastLogEntry(log: string[]): string {
    if (log && log.length > 0) {
      return log[log.length - 1].substr(0, 150);
    } else {
      return "";
    }
  }

}

function setToMonday(date: Date): Date {
  var day = date.getDay() || 7;
  if (day !== 1)
    date.setHours(-24 * (day - 1));
  return date;
}